module.exports = __webpack_public_path__ + "img/maya-1-creativo.b65d86ae.png";